interface PhoneButtonProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function PhoneButton({ className = '', size = 'md' }: PhoneButtonProps) {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  return (
    <a
      href="tel:05416247982"
      className={`inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer shadow-lg hover:shadow-orange-200 ${sizeClasses[size]} ${className}`}
    >
      <span className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full">
        <i className="ri-phone-fill text-sm"></i>
      </span>
      0541 624 79 82
    </a>
  );
}
